var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 227,
    viewBox: "0 0 246 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LOGO"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 47",
    d: "M146.751 68.7774L116.57 6.00763L80.0757 6.19461L18.0599 205.578L66.9955 205.327C60.8352 190.152 53.1289 146.878 76.6174 140.656C105.608 132.976 117.267 142.032 153.621 114.474C136.322 137.787 71.6321 138.948 71.6491 142.266L90.3772 74.1558L111.942 74.0453L116.994 88.7194M94.0723 133.035C97.7109 115.866 105.694 100.58 116.994 88.7194M83.3459 158.795C184.692 188.965 177.674 114.351 222.254 73.4801C178.919 54.0493 140.674 63.8623 116.994 88.7194",
    stroke: "#235B22",
    strokeWidth: 1.65886
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 46",
    filter: "url(#filter0_d_341_487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0599 205.578L80.0757 6.19461L116.57 6.00763L146.751 68.7774C135.323 73.1835 125.269 80.0329 116.994 88.7194L111.942 74.0453L90.3772 74.1558L73.3036 141.428C53.469 155.464 60.8352 190.152 66.9955 205.327L18.0599 205.578Z",
    fill: "#49C93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.751 68.7774L116.57 6.00763L80.0757 6.19461L18.0599 205.578L66.9955 205.327C60.8352 190.152 53.469 155.464 73.3036 141.428L90.3772 74.1558L111.942 74.0453L116.994 88.7194M94.0723 133.035C97.7109 115.866 105.694 100.58 116.994 88.7194M222.254 73.4801C178.919 54.0493 140.674 63.8623 116.994 88.7194",
    stroke: "#235B22",
    strokeWidth: 1.65886
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 46_2",
    filter: "url(#filter1_d_341_487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.908 201.215L184.906 136.713C177.044 153.342 159.681 164.214 153.88 165.073L178.687 201.441L222.908 201.215Z",
    fill: "#49C93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.908 201.215L184.906 136.713C177.044 153.342 159.681 164.214 153.88 165.073L178.687 201.441L222.908 201.215Z",
    stroke: "#235B22",
    strokeWidth: 1.65886
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 47_2",
    d: "M93.2451 133.597C96.8837 116.428 104.867 101.142 116.167 89.281C139.847 64.4239 178.092 54.6109 221.427 74.0417C176.847 114.913 184.691 188.965 83.3453 158.795",
    stroke: "#235B22",
    strokeWidth: 1.65886
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector 48",
    filter: "url(#filter2_f_341_487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.7762 128.019C104.651 108.113 112.124 97.2664 122.783 85.5993C142.579 63.9325 179.018 52.9631 220.582 70.9978C182.629 110.176 183.688 181.992 90.7886 154.607",
    stroke: "#49C93E",
    strokeWidth: 1.65886
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 49",
    filter: "url(#filter3_f_341_487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.996 127.738C108.47 109.966 115.325 100.282 125.104 89.8648C143.263 70.5194 176.686 60.7219 214.806 76.8171C179.991 111.798 180.953 175.911 95.7497 151.475",
    stroke: "#49C93E",
    strokeWidth: 1.65886
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 50",
    filter: "url(#filter4_f_341_487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.1477 129.975C103.681 111.533 110.631 101.485 120.543 90.6755C138.952 70.6023 172.839 60.4392 211.49 77.1465C176.195 113.443 177.179 179.976 90.7893 154.607",
    stroke: "#49C93E",
    strokeWidth: 1.65886
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 51",
    filter: "url(#filter5_f_341_487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.6914 131.639C102.976 114.203 109.545 104.703 118.915 94.4833C136.315 75.505 168.344 65.8963 204.878 81.6923C171.517 116.009 172.447 178.913 90.791 154.928",
    stroke: "#49C93E",
    strokeWidth: 1.65886
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 52",
    filter: "url(#filter6_f_341_487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.203 131.613C107.239 115.183 113.427 106.23 122.254 96.6006C138.645 78.7172 168.818 69.6629 203.234 84.5476C171.807 116.885 172.683 176.159 95.7606 153.558",
    stroke: "#49C93E",
    strokeWidth: 1.65886
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 54",
    filter: "url(#filter7_f_341_487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.222 126.611C110.762 112.193 116.188 104.337 123.929 95.886C138.303 80.1925 164.762 72.247 194.942 85.3092C167.383 113.687 168.151 165.703 100.696 145.869",
    stroke: "#49C93E",
    strokeWidth: 1.65886
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_341_487",
    x: 10.2962,
    y: 5.17578,
    width: 218.933,
    height: 214.508,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.63542
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.31771
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.137255 0 0 0 0 0.356863 0 0 0 0 0.133333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_341_487"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_341_487",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_341_487",
    x: 145.813,
    y: 134.943,
    width: 85.1778,
    height: 80.6009,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.63542
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.31771
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_341_487"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_341_487",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_341_487",
    x: 77.2834,
    y: 47.8356,
    width: 157.999,
    height: 126.947,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.63542,
    result: "effect1_foregroundBlur_341_487"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_341_487",
    x: 83.909,
    y: 56.2913,
    width: 143.964,
    height: 113.044,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.80599,
    result: "effect1_foregroundBlur_341_487"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_341_487",
    x: 80.6025,
    y: 57.9697,
    width: 142.274,
    height: 113.048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.97657,
    result: "effect1_foregroundBlur_341_487"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_341_487",
    x: 80.6042,
    y: 62.9726,
    width: 135.66,
    height: 108.059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.97657,
    result: "effect1_foregroundBlur_341_487"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_341_487",
    x: 83.9149,
    y: 64.6273,
    width: 132.364,
    height: 106.386,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.80599,
    result: "effect1_foregroundBlur_341_487"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_341_487",
    x: 87.1913,
    y: 64.6461,
    width: 122.454,
    height: 99.7233,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.63542,
    result: "effect1_foregroundBlur_341_487"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogin);
export default __webpack_public_path__ + "static/media/LOGO-LOGIN.951ada112457cb2ad03a986c297ce608.svg";
export { ForwardRef as ReactComponent };